import { useMemo } from "react"
import { useAdsbTracking } from "./useAdsbTracking"
import { useSpidertracksTracking } from "./useSpidertracksTracking"

export const useTrackedAircraft = ({
    orgId,
    id,
}: {
    orgId: string | undefined
    id: string | null | undefined
}) => {
    const { rawAircraft } = useAdsbTracking(orgId)
    const { data: spidertracksData } = useSpidertracksTracking(orgId)
    return useMemo(
        () =>
            [...(rawAircraft ?? []), ...(spidertracksData?.aircraft ?? [])].find(
                (craft) => craft.id === id
            ),
        [rawAircraft, spidertracksData, id]
    )
}
